// Formatting utilities for Swiss Finance OS

export const formatSwissCurrency = (amount: number): string => {
  return new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const formatSwissDate = (date: string | Date): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('de-CH').format(d);
};

export const formatPercentage = (value: number): string => {
  return `${value.toFixed(2)}%`;
};
